import React, { useEffect, useState } from "react";
import "../../assets/styles/auth/register.scss";
import { useNavigate, useSearchParams } from "react-router-dom";
import NewInput from "../../components/simple/NewInput";
import { apiRegister, apiSetAlert } from "../../api/appApi";
import { appReset } from "../../store/actions/appAction";
import { useDispatch, useSelector } from "react-redux";
import { formatMobile } from "../../helpers";
import iconLoading from "../../assets/svg/icon-loading.svg";
import Lottie from "../../components/public/Lottie";
import { RecaptchContainer, StyledReCAPTCHA } from "./components";

import { styled } from "@mui/material";
import Captcha from "./Captcha";
import { dicHasval } from "helpers/helper";

const RegisterWrapper = styled("div")(({ theme }) => ({
  "@media (max-width: 575px)": {
    marginTop: "100px",
  },
}));

export default function Register() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const sendingRequest = useSelector((state) => state.appReducer.sendingRequest);
  const [queryParams, setQueryParams] = useState({});
  const [reCaptcha, setReCaptcha] = useState(false);
  const [acceptPrivacy, setAcceptPrivacy] = useState(false);
  const [referralCode, setReferralCode] = useState(false);
  const [inputFields, setInputFields] = useState({
    firstName: null,
    lastName: null,
    email: null,
    phone: null,
    password: null,
    confirmPassword: null,
  });

  useEffect(() => {
    // Function to extract query parameters and convert them to an object
    const getQueryParams = () => {
      const params = new URLSearchParams(window.location.search);
      const paramsObj = {};
      for (let [key, value] of params.entries()) {
        paramsObj[key] = value;
      }
      return paramsObj;
    };
    // Set the query parameters in the state
    const paramsObj = getQueryParams();
    if(dicHasval(paramsObj)){
          localStorage.setItem("query_Params",JSON.stringify(paramsObj))
        }
    setQueryParams(paramsObj);
  }, []);
  useEffect(() => {
    dispatch(appReset());
  }, []);

  function goToLogin() {
    navigate("/auth/login");
  }

  function toggleReferralCode() {
    setReferralCode(!referralCode);
  }

  function RegisterStepOne() {
    if (!reCaptcha) {
      dispatch(apiSetAlert("لطفا راستی آزمایی را تکمیل نمایید", "warning"));
    } else if (!acceptPrivacy) {
      dispatch(apiSetAlert("لطفا متن قوانین و راهنما را ثبول نمایید", "warning"));
    } else {
      dispatch(apiRegister(inputFields, navigate,queryParams));
    }
  }

  return (
    <div className="wrap-register-parent">
      <RegisterWrapper className="wrap-register">
        <div className="img-background-auth">
          <Lottie />
        </div>
        <form>
          <h5>در چرتکه ثبت نام کنید</h5>
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-login-in-register">
              قبلا ثبت نام کرده اید؟ <b onClick={goToLogin}>از این جا وارد شوید</b>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12 mt-2">
              <NewInput
                type={"text"}
                onChange={(e) =>
                  setInputFields((prev) => {
                    return {
                      firstName: e.target.value ?? null,
                      lastName: prev.lastName,
                      email: prev.email,
                      phone: prev.phone,
                      password: prev.password,
                      confirmPassword: prev.confirmPassword,
                    };
                  })
                }
                placeholder={"نام"}
                label={"اطلاعات شخصی *"}
              />
            </div>
            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
              <NewInput
                type={"text"}
                placeholder={"نام خانوادگی "}
                label={""}
                onChange={(e) =>
                  setInputFields((prev) => {
                    return {
                      lastName: e.target.value ?? null,
                      firstName: prev.firstName,
                      email: prev.email,
                      phone: prev.phone,
                      password: prev.password,
                      confirmPassword: prev.confirmPassword,
                    };
                  })
                }
              />
            </div>
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-2">
              <NewInput
                type={"text"}
                label={"اطلاعات تماس *"}
                placeholder={"شماره موبایل"}
                onChange={(e) =>
                  setInputFields((prev) => {
                    return {
                      phone: formatMobile(e.target.value) ?? null,
                      email: prev.email,
                      firstName: prev.firstName,
                      lastName: prev.lastName,
                      password: prev.password,
                      confirmPassword: prev.confirmPassword,
                    };
                  })
                }
                value={inputFields.phone}
              />
            </div>
            {/*<div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">*/}
            {/*  <NewInput*/}
            {/*    type={"email"}*/}
            {/*    placeholder={"ایمیل"}*/}
            {/*    label={""}*/}
            {/*    onChange={(e) =>*/}
            {/*      setInputFields((prev) => {*/}
            {/*        return {*/}
            {/*          email: e.target.value ?? null,*/}
            {/*          firstName: prev.firstName,*/}
            {/*          lastName: prev.lastName,*/}
            {/*          phone: prev.phone,*/}
            {/*          password: prev.password,*/}
            {/*          confirmPassword: prev.confirmPassword,*/}
            {/*        };*/}
            {/*      })*/}
            {/*    }*/}
            {/*  />*/}
            {/*</div>*/}
            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12 mt-2">
              <NewInput
                type={"password"}
                placeholder={"رمز عبور"}
                label={"رمز عبور *"}
                onChange={(e) =>
                  setInputFields((prev) => {
                    return {
                      password: e.target.value ?? null,
                      email: prev.email,
                      firstName: prev.firstName,
                      lastName: prev.lastName,
                      phone: prev.phone,
                      confirmPassword: prev.confirmPassword,
                    };
                  })
                }
              />
            </div>
            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
              <NewInput
                type={"password"}
                placeholder={"تکرار رمز عبور"}
                label={""}
                onChange={(e) =>
                  setInputFields((prev) => {
                    return {
                      confirmPassword: e.target.value ?? null,
                      email: prev.email,
                      firstName: prev.firstName,
                      lastName: prev.lastName,
                      phone: prev.phone,
                      password: prev.password,
                    };
                  })
                }
              />
            </div>
            {/*<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-login-in-register">*/}
            {/*  <img*/}
            {/*    className={*/}
            {/*      showToggleCodeInput == true*/}
            {/*        ? "active-arrow-blue-img arrow-blue-img"*/}
            {/*        : "arrow-blue-img"*/}
            {/*    }*/}
            {/*    src={ArrowBlue}*/}
            {/*    alt="ArrowBlue"*/}
            {/*    onClick={() => toggleReferralCode()}*/}
            {/*  />*/}
            {/*  <b>کد معرف دارید؟</b>*/}
            {/*</div>*/}
            {referralCode === true ? (
              <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12 colection-inputs-register mt-2">
                <NewInput placeholder={"کد معرف (اختیاری)"} type={"text"} />
              </div>
            ) : (
              <></>
            )}
            <div className="py-4">
              <Captcha validate={(res) => setReCaptcha(res)} submit={RegisterStepOne} />
            </div>
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 form-check-register p-4">
              <input
                className="form-check-input"
                type="checkbox"
                value="1"
                checked={acceptPrivacy}
                onChange={(e) => setAcceptPrivacy(!acceptPrivacy)}
                id="flexCheckDefault"
              />
              <label className="form-check-label" for="flexCheckDefault">
                <a
                  className="text-condition-auth"
                  href="https://chortke.app/terms-of-software"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span>شرایط استفاده و حفظ حریم خصوصی </span>
                </a>
                <span>را خوانده و با آن موافقم</span>
              </label>
            </div>
            {/* <RecaptchContainer>
              <StyledReCAPTCHA
                sitekey="6Ld6C7IcAAAAAKO3b-DCLe56b0yEQ7LM1Rjuh_-B"
                hl={"fa"}
                onChange={() => setReCaptcha(true)}
              />
            </RecaptchContainer> */}

            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 btns">
              <button
                type="button"
                className="btn-enter"
                disabled={sendingRequest}
                onClick={() => RegisterStepOne()}
              >
                {sendingRequest ? <img src={iconLoading} alt="loading" /> : "ثبت نام"}
              </button>
            </div>
            <div style={{ height: "10px" }} />
          </div>
        </form>
      </RegisterWrapper>
    </div>
  );
}
